var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs-items',{attrs:{"value":_vm.value,"touchless":_vm.isTouchless},on:{"change":_vm.emitInput}},[(_vm.isStatic)?_vm._t("default"):_vm._l((_vm.items),function(item,itemIndex){return _c('tab-item',{key:itemIndex,attrs:{"index":itemIndex,"tab-class":_vm.tabClass}},[_vm._t("default",null,null,{ item, itemIndex })],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }